import { connect } from 'react-redux'

import analyticsActions from 'models/Analytics/actions'
import generalActions from 'models/General/actions'
import profileActions from 'models/ProfileInfo/actions'
import profileSelectors from 'models/ProfileInfo/selectors'
import generalSelectors from 'models/General/selectors'
import authSelectors from 'models/Authentication/selectors'
import WithAnalyticsHandlers from './WithAnalyticsHandlers'

export const mapStateToProps = (state) => ({
  accountId: profileSelectors.getUserId(state),
  userAlias: profileSelectors.getUserAlias(state),
  intercomUserHashWeb: generalSelectors.getIntercomUserHashWeb(state),
  isAuthenticated: authSelectors.getIsAuthenticated(state),
})

export const mapDispatchToProps = {
  updateAnalyticsUserId: analyticsActions.updateAnalyticsUserId.init,
  fetchIntercomUserHash: generalActions.fetchIntercomUserHash.init,
  setReklaimRewardsTag: profileActions.setReklaimRewardsTag.init,
}

export default connect(mapStateToProps, mapDispatchToProps)(WithAnalyticsHandlers)
